import { CalculationTrace } from './calculation-trace.types';

/** Plain text version of a trace: what the admin copies to the clipboard to audit a number outside the app. */
export function traceToText(trace: CalculationTrace): string {
  const blocks = trace.steps.map((step, index) => {
    const lines = [
      `${index + 1}. ${step.label}`,
      `   ${step.formula}`,
      `   ${step.substituted}`,
      `   = ${step.result}${step.unit ? ` ${step.unit}` : ''}`,
    ];
    if (step.note) {
      lines.push(`   Note: ${step.note}`);
    }
    if (step.inputs.length > 0) {
      lines.push('   Inputs:');
      step.inputs.forEach((input) => lines.push(`     - ${input.name} = ${input.value} (${input.source})`));
    }
    return lines.join('\n');
  });
  return [trace.subject, ...blocks].join('\n\n');
}
